import useAuth from '@/hooks/useAuth'
import {useRouter} from 'next/router'
import {Dispatch, SetStateAction} from 'react'

type Props = {
  setIsLoginOpen: (arg0: boolean) => void
  setIsRegisterOpen: (arg0: boolean) => void

  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
  lastOpened: 'login' | 'register'
  toggleClick: any
}
export default function LoggedInUserMobile({
  setIsLoginOpen,
  setIsRegisterOpen,
  setLastOpened,
  lastOpened,
  toggleClick,
}: Props) {
  const {user} = useAuth('none')
  const router = useRouter()
  return (
    <a
      href="#"
      onClick={e => {
        e.preventDefault()
        if (user) {
          toggleClick()
          router.push('/account')
        } else {
          if (lastOpened == 'register') {
            setLastOpened('register')
            setIsRegisterOpen(true)
          } else {
            setLastOpened('login')
            setIsLoginOpen(true)
          }
        }
      }}
      className="w-[100%] flex flex-row mt-8 justify-between align-middle items-center p-4 rounded-lg bg-[#F5F6FA]">
      <div className="flex flex-row align-middle items-center">
        <div className="ml-2">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_742_10744)">
              <path
                d="M12 12.4999C13.1867 12.4999 14.3467 12.148 15.3334 11.4887C16.3201 10.8294 17.0892 9.89234 17.5433 8.79598C17.9974 7.69963 18.1162 6.49323 17.8847 5.32934C17.6532 4.16545 17.0818 3.09635 16.2426 2.25724C15.4035 1.41812 14.3344 0.84668 13.1705 0.615169C12.0067 0.383658 10.8003 0.502478 9.7039 0.956603C8.60754 1.41073 7.67047 2.17976 7.01118 3.16646C6.35189 4.15315 6 5.31319 6 6.49988C6.00159 8.09069 6.63424 9.61589 7.75911 10.7408C8.88399 11.8656 10.4092 12.4983 12 12.4999ZM12 2.49988C12.7911 2.49988 13.5645 2.73448 14.2223 3.174C14.8801 3.61353 15.3928 4.23824 15.6955 4.96915C15.9983 5.70005 16.0775 6.50432 15.9231 7.28024C15.7688 8.05617 15.3878 8.7689 14.8284 9.32831C14.269 9.88772 13.5563 10.2687 12.7804 10.423C12.0044 10.5774 11.2002 10.4981 10.4693 10.1954C9.73836 9.89265 9.11365 9.37996 8.67412 8.72216C8.2346 8.06436 8 7.29101 8 6.49988C8 5.43901 8.42143 4.4216 9.17157 3.67145C9.92172 2.92131 10.9391 2.49988 12 2.49988Z"
                fill="#00214D"
              />
              <path
                d="M12 14.5C9.61386 14.5026 7.32622 15.4517 5.63896 17.139C3.95171 18.8262 3.00265 21.1139 3 23.5C3 23.7652 3.10536 24.0196 3.29289 24.2071C3.48043 24.3946 3.73478 24.5 4 24.5C4.26522 24.5 4.51957 24.3946 4.70711 24.2071C4.89464 24.0196 5 23.7652 5 23.5C5 21.6435 5.7375 19.863 7.05025 18.5503C8.36301 17.2375 10.1435 16.5 12 16.5C13.8565 16.5 15.637 17.2375 16.9497 18.5503C18.2625 19.863 19 21.6435 19 23.5C19 23.7652 19.1054 24.0196 19.2929 24.2071C19.4804 24.3946 19.7348 24.5 20 24.5C20.2652 24.5 20.5196 24.3946 20.7071 24.2071C20.8946 24.0196 21 23.7652 21 23.5C20.9974 21.1139 20.0483 18.8262 18.361 17.139C16.6738 15.4517 14.3861 14.5026 12 14.5Z"
                fill="#00214D"
              />
            </g>
            <defs>
              <clipPath id="clip0_742_10744">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <h1 className="text-md text-primary font-bold text-center">
          {!user ? 'حسابي' : 'مرحباً, ' + user?.first_name}
        </h1>
      </div>
    </a>
  )
}
